/* DCM late-patch v17 — hero: 8 slides + IMAGE-MATCHED text per slide.
   Cache-bust: 2026-05-14-hero-v17-image-matched-copy */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ============================================================
  // HERO: 8 slides + per-image text variation
  // ============================================================
  // Each unique hero image gets its OWN heading + lead + highlight
  // that fits what the user is looking at. As slides cycle (auto-tick
  // or arrow tap), text rotates IN SYNC with the imagery:
  //
  //   * 294418_thumbnail.png — residential villa, garage opening at
  //     dusk, car arriving home → "convenience / automation / home"
  //   * hero2.png — modern interior with flush entry door, gallery
  //     lighting → "design / architecture / premium interior"
  //   * hero3.png — industrial multi-bay facility with rolling
  //     shutters → "industrial / scale / non-stop operation"
  //
  // Fallback variation is used for any image we don't have a map for
  // (e.g. admin uploads a new slide image we haven't keyed).
  var DCM_HERO_IMAGE_COPY = {
    '294418_thumbnail.png': {
      heading: 'Uși de garaj montate într-o zi.',
      highlight: 'ÎNTR-O ZI.',
      lead: 'Măsurăm la tine acasă, gratuit. Ofertă concretă în 24 de ore. Montaj profesionist într-o singură zi, cu garanție 5 ani la produs și manoperă.'
    },
    'hero2.png': {
      heading: 'Hörmann, BFT, Nice — direct la tine.',
      highlight: 'DIRECT LA TINE.',
      lead: 'Direct importatori, fără intermediari. Echipă proprie de instalatori certificați, garanție extinsă, service propriu în toate cele 41 de județe.'
    },
    'hero3.png': {
      heading: 'Uși industriale până la 8 metri.',
      highlight: 'PÂNĂ LA 8 METRI.',
      lead: 'Uși rapide, secționale, rulouri de oțel pentru hale, depozite și ateliere. Proiecte la cheie, măsurate și montate într-o singură deplasare.'
    }
  };
  var DCM_HERO_FALLBACK = {
    heading: 'Uși de garaj montate într-o zi.',
    highlight: 'ÎNTR-O ZI.',
    lead: 'Hörmann, BFT, Nice — direct importatori. Echipă proprie de montaj, garanție 5 ani, service în toate cele 41 de județe.'
  };

  function imageBasename(slideEl) {
    var img = slideEl.querySelector('img');
    if (!img || !img.src) return null;
    return img.src.split('/').pop().split('?')[0];
  }
  function copyForSlide(slideEl) {
    var base = imageBasename(slideEl);
    if (base && DCM_HERO_IMAGE_COPY[base]) return DCM_HERO_IMAGE_COPY[base];
    return DCM_HERO_FALLBACK;
  }

  function applyHeroVariations() {
    var hero = document.querySelector('.hero');
    if (!hero) return false;
    var slides = hero.querySelectorAll('.hero__slide');
    if (slides.length === 0) return false;

    // 1. Clone existing slides until we have 8 total — images cycle.
    //    Done before any text-setting so clones inherit the correct
    //    img.src and we can key text off it.
    var TARGET_SLIDES = 8;
    if (slides.length < TARGET_SLIDES) {
      var originals = Array.from(slides);
      var parent = originals[0].parentNode;
      var i = 0;
      while (parent.querySelectorAll('.hero__slide').length < TARGET_SLIDES) {
        var clone = originals[i % originals.length].cloneNode(true);
        clone.removeAttribute('aria-hidden');
        clone.classList.remove('is-active', 'is-visible');
        parent.appendChild(clone);
        i++;
      }
    }

    // 2. Assign image-matched text to EACH slide individually.
    //    The hero slideshow controller reads dataset.heading/lead/
    //    highlight on the active slide every transition, so this
    //    drives the per-slide swap automatically.
    var firstPick = null;
    Array.from(document.querySelectorAll('.hero__slide')).forEach(function (s, i) {
      var pick = copyForSlide(s);
      s.dataset.heading = pick.heading;
      s.dataset.lead = pick.lead;
      s.dataset.highlight = pick.highlight;
      if (i === 0) firstPick = pick;
    });

    // 3. Render the FIRST slide's text immediately so users don't see
    //    a flash of the server-rendered default before the slideshow
    //    controller boots and calls swapHeroContent.
    if (!firstPick) firstPick = DCM_HERO_FALLBACK;
    var headingEl = document.querySelector('.hero__heading');
    var leadEl = document.querySelector('.hero__lead');
    if (headingEl) {
      var lower = firstPick.heading.toLowerCase();
      var hl = firstPick.highlight.toLowerCase();
      var idx = lower.indexOf(hl);
      var html;
      if (idx >= 0 && firstPick.highlight) {
        var before = firstPick.heading.slice(0, idx);
        var match = firstPick.heading.slice(idx, idx + firstPick.highlight.length);
        var after = firstPick.heading.slice(idx + firstPick.highlight.length);
        html =
          escapeHtml(before) +
          '<span class="hero__heading-mark" style="--mark-rotation:-0.6deg">' + escapeHtml(match) + '</span>' +
          escapeHtml(after);
      } else {
        html = escapeHtml(firstPick.heading);
      }
      headingEl.innerHTML = html;
    }
    if (leadEl) leadEl.textContent = firstPick.lead;

    return true;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── DISABLED 2026-05-25 ──────────────────────────────────────────
  // Hero patching is OFF. The user now controls hero slide content
  // (image / heading / lead / highlight) entirely from the Shopify
  // theme editor. The hardcoded DCM_HERO_IMAGE_COPY map above was
  // hijacking those admin edits on every page load — slides were
  // being cloned to 8 and text overridden. Re-enable only if you
  // explicitly want to lock the hero copy in code again.
  // applyHeroVariations();
  // ready(applyHeroVariations);


  function injectCSS() {
    if (document.getElementById('dcm-late-css')) return;
    var s = document.createElement('style');
    s.id = 'dcm-late-css';
    s.textContent =
      // Process section: orange bg, dark cards (so the section
      // separates from the dark footer right below it).
      'html body .process { background:#f7941d !important; color:#0e0e10 !important; }' +
      'html body .process .process__head h2, html body .process .process__head .eyebrow { color:#0e0e10 !important; }' +
      'html body .process .lead, html body .process .process__head .lead { color: rgba(14,14,16,0.78) !important; }' +
      'html body .process .process__step { background:#0e0e10 !important; }' +
      'html body .process .process__step-text { color: rgba(244,243,239,0.78) !important; }' +
      'html body .process .process__step-title { color: #fafaf7 !important; }' +
      'html body .process .process__step-num { display: none !important; }' +
      // 404 legibility
      'html body .not-found h1, html body .template-404 h1 { color: #f7941d !important; }' +
      // Page banner: trim padding, hide solid orange hairline
      'html body .page-header, html body .collection__header, html body .breadcrumb-hero { padding-top: clamp(3rem, 4vw, 5rem) !important; padding-bottom: clamp(2rem, 3vw, 4rem) !important; }' +
      'html body .page-header + hr, html body .collection__header + hr, html body .breadcrumb-hero + hr { display: none !important; }' +
      // Cookie banner
      '#dcm-cookie-banner { position: fixed; left: 0; right: 0; bottom: 0; z-index: 9999; background: #0e0e10; color: #fafaf7; padding: 1.4rem 2rem; box-shadow: 0 -8px 24px rgba(0,0,0,0.4); border-top: 4px solid #f7941d; display: none; }' +
      '#dcm-cookie-banner.is-visible { display: block; }' +
      '#dcm-cookie-banner__inner { max-width: 1200px; margin: 0 auto; display: flex; gap: 1.6rem; align-items: center; flex-wrap: wrap; justify-content: space-between; font-family: Inter, system-ui, sans-serif; font-size: 1.3rem; line-height: 1.5; }' +
      '#dcm-cookie-banner p { margin: 0; flex: 1 1 auto; min-width: 220px; }' +
      '#dcm-cookie-banner a { color: #f7941d; text-decoration: underline; }' +
      '#dcm-cookie-banner__btn { font-family: "Bebas Neue", Inter, sans-serif; font-size: 1.4rem; letter-spacing: 0.08em; text-transform: uppercase; background: #f7941d; color: #0e0e10; border: 0; padding: 1rem 1.8rem; cursor: pointer; flex: 0 0 auto; }' +
      '#dcm-cookie-banner__btn:hover { background: #fafaf7; }' +
      // Drop redundant Acasă from MAGAZIN footer column
      'html body .footer__col ul li:has(> a[href="/"]) { display: none; }' +
      // Mobile subcategory slider — kill edge fade + trailing padding matches leading
      'html .dcm-cl-subs__grid, html .dcm-cl-subs__grid.is-at-start, html .dcm-cl-subs__grid.is-at-end { -webkit-mask-image: none !important; mask-image: none !important; }' +
      '@media (max-width: 989px) {' +
        ' html .dcm-cl-subs__grid { padding-right: 1.6rem !important; }' +
        ' html .dcm-cl-subs .dcm-cl-sub-card:last-child { margin-right: 0 !important; scroll-snap-align: start !important; }' +
      '}' +
      // Hide Shopify's built-in cookie consent banner — using our custom one
      'html body #shopify-pc__banner, html body .shopify-pc__banner, html body [data-shopify-pc-banner], html body [data-shopify-pc-modal], html body dialog[data-shopify-pc-modal], html body #shopify-pc-root { display: none !important; visibility: hidden !important; }' +
      // Sticky WhatsApp / phone floating buttons (bottom-right, mobile + desktop)
      '#dcm-stick { position: fixed; right: 1.6rem; bottom: 1.6rem; z-index: 9998; display: flex; flex-direction: column; gap: 1rem; }' +
      '@media (max-width: 749px) { #dcm-stick { right: 1rem; bottom: 1rem; gap: 0.8rem; } }' +
      '#dcm-stick a { display: inline-flex; align-items: center; justify-content: center; width: 56px; height: 56px; border-radius: 50%; background: #25d366; color: #fff; box-shadow: 0 6px 18px rgba(0,0,0,0.25); transition: transform 0.18s ease, box-shadow 0.18s ease; text-decoration: none; }' +
      '#dcm-stick a:hover { transform: translateY(-3px); box-shadow: 0 10px 28px rgba(0,0,0,0.35); }' +
      '#dcm-stick a.dcm-stick--phone { background: #f7941d; color: #0e0e10; }' +
      '#dcm-stick a svg { width: 26px; height: 26px; }' +
      '#dcm-stick a:focus-visible { outline: 3px solid #fafaf7; outline-offset: 3px; }' +
      // Hide on /cart and during checkout to not block CTAs
      'body.template-cart #dcm-stick, body.template-checkout #dcm-stick { display: none; }' +
      // Cookie banner: extra padding when stick is visible so they don't overlap
      '#dcm-cookie-banner.is-visible ~ #dcm-stick, body:has(#dcm-cookie-banner.is-visible) #dcm-stick { bottom: 8.4rem; }' +
      '';
    document.head.appendChild(s);
  }

  function cleanMobileMenu() {
    var list = document.querySelector('.mobile-menu__list');
    if (!list) return;
    Array.from(list.children).forEach(function (li) {
      var t = (li.textContent || '').trim();
      if (/^(contul meu|contact)$/i.test(t)) li.remove();
    });
    var wrap = list.querySelector('.dcm-mobile-catalog');
    if (wrap) {
      var panel = wrap.querySelector('.dcm-mobile-catalog__panel');
      if (panel) Array.from(panel.children).forEach(function (li) { list.insertBefore(li, wrap); });
      wrap.remove();
    }
  }

  function hideMobileAnnouncementBar() {
    if (window.innerWidth > 989) return;
    document.querySelectorAll('.announcement.announcement--contact, .shopify-section-group-header-group .announcement, .shopify-section-group-header-group #dcm-hazard-mid, .shopify-section-group-header-group hr.hazard').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function patchPasLabels() {
    document.querySelectorAll('.process__step-num').forEach(function (el) {
      var m = el.textContent.match(/PAS\s*0?(\d+)/);
      if (m && el.textContent !== 'PAS ' + parseInt(m[1], 10)) el.textContent = 'PAS ' + parseInt(m[1], 10);
    });
  }

  function patchPhoneBox() {
    var box = document.querySelector('.quote-form__intro');
    if (!box || box.dataset.dcmTelPatched) return;
    var tel = box.querySelector('a[href^="tel"]');
    if (!tel) return;
    var num = (tel.getAttribute('href') || '').replace(/^tel:\s*/i, '').trim() || '+40741117722';
    var pretty = num.replace(/\s+/g, '');
    var m = pretty.match(/^(\+\d{2})(\d{2})(\d{3})(\d{2})(\d{2})$/);
    if (m) pretty = m[1] + ' ' + m[2] + ' ' + m[3] + ' ' + m[4] + ' ' + m[5];
    else pretty = '+40 74 111 77 22';
    var wrap = tel.closest('div');
    if (wrap && wrap !== box) {
      wrap.innerHTML = '';
      var newA = document.createElement('a');
      newA.href = 'tel:' + num;
      newA.style.cssText = 'display:block;padding:2rem;background:#0e0e10;color:#fafaf7;text-decoration:none;font-family:"Bebas Neue","Inter",sans-serif;font-size:2.4rem;font-weight:700;letter-spacing:0.06em';
      newA.innerHTML = '<span style="color:#fafaf7">Sună-ne:</span><span style="color:#f7941d;white-space:nowrap;margin-left:0.4rem">' + pretty + '</span>';
      wrap.appendChild(newA);
      wrap.style.cssText = (wrap.style.cssText || '') + ';margin-top:2rem;padding:0;background:transparent;border:0';
    } else {
      tel.innerHTML = '<span style="color:#fafaf7">Sună-ne:</span> <span style="color:#f7941d;white-space:nowrap">' + pretty + '</span>';
      tel.style.cssText = 'display:block;padding:2rem;background:#0e0e10;color:#fafaf7;text-decoration:none;font-family:"Bebas Neue","Inter",sans-serif;font-size:2.4rem;font-weight:700;letter-spacing:0.06em';
    }
    box.dataset.dcmTelPatched = '1';
  }

  function fix404() {
    if (!document.body.classList.contains('template-404') && !/404/i.test(document.title)) return;
    document.querySelectorAll('h1').forEach(function (h) {
      if (/^\s*404\s*$/.test(h.textContent)) {
        h.style.color = '#f7941d';
        h.style.textShadow = '0 4px 24px rgba(14,14,16,0.6)';
      }
    });
  }

  function reinforceFavicon() {
    // iOS uses apple-touch-icon for Safari search-results / bookmarks / home-screen icon.
    // Without it, iOS scales up the 32×32 favicon → blurry. Find the existing favicon URL,
    // request larger sizes from Shopify CDN, and inject apple-touch-icon links.
    var existing = document.querySelector('link[rel="icon"]');
    if (!existing) return;
    var src = existing.href;
    if (!src) return;
    // Replace any width/height query in the URL
    function withSize(s) {
      return src.replace(/([?&])(width|height)=\d+/g, '$1$2=' + s).replace(/&width=\d+/, '&width=' + s).replace(/height=\d+/, 'height=' + s);
    }
    var sizes = [180, 152, 120];
    sizes.forEach(function (sz) {
      if (document.querySelector('link[rel="apple-touch-icon"][sizes="' + sz + 'x' + sz + '"]')) return;
      var l = document.createElement('link');
      l.rel = 'apple-touch-icon';
      l.setAttribute('sizes', sz + 'x' + sz);
      l.href = withSize(sz);
      document.head.appendChild(l);
    });
    // Also add a high-res 192px PNG icon for Android/Chrome
    if (!document.querySelector('link[rel="icon"][sizes="192x192"]')) {
      var l = document.createElement('link');
      l.rel = 'icon';
      l.type = 'image/png';
      l.setAttribute('sizes', '192x192');
      l.href = withSize(192);
      document.head.appendChild(l);
    }
  }

  function reinforceThemeColor() {
    if (document.getElementById('dcm-tc-light')) return;
    var tags = [
      ['theme-color', '#0e0e10', '(prefers-color-scheme: light)', 'dcm-tc-light'],
      ['theme-color', '#0e0e10', '(prefers-color-scheme: dark)', 'dcm-tc-dark'],
      ['msapplication-navbutton-color', '#0e0e10', null, 'dcm-tc-msnav'],
      ['apple-mobile-web-app-status-bar-style', 'black-translucent', null, 'dcm-tc-applebar'],
      ['apple-mobile-web-app-capable', 'yes', null, 'dcm-tc-applecap']
    ];
    tags.forEach(function (t) {
      var m = document.createElement('meta');
      m.name = t[0]; m.content = t[1]; m.id = t[3];
      if (t[2]) m.media = t[2];
      document.head.appendChild(m);
    });
  }

  // ---------- SEO: title dedup only (map removed) ----------
  function applySEOForCurrentPage() {
    var t = document.title;
    var dedup = t.replace(/\s*[-–—|]\s*D\.?C\.?\s*MARKET(\s*[-–—|]\s*D\.?C\.?\s*MARKET)+\s*$/gi, ' | DC MARKET');
    dedup = dedup.replace(/\s+[–—-]\s+/g, ' | ');
    if (dedup !== t) document.title = dedup;
  }

  // ---------- Sticky WhatsApp + Phone floating buttons ----------
  function injectStickyCTA() {
    if (document.getElementById('dcm-stick')) return;
    var phone = '+40741117722';
    var whatsapp = '40741117722';
    var msg = encodeURIComponent('Bună ziua! AȘ dori o ofertă pentru o ușă.');
    var box = document.createElement('div');
    box.id = 'dcm-stick';
    box.innerHTML =
      '<a class="dcm-stick--whatsapp" href="https://wa.me/' + whatsapp + '?text=' + msg + '" target="_blank" rel="noopener" aria-label="Scrie pe WhatsApp" title="WhatsApp">' +
        '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.52 3.48A11.94 11.94 0 0012.04 0C5.46 0 .12 5.34.12 11.92c0 2.1.55 4.16 1.6 5.97L0 24l6.27-1.65a11.91 11.91 0 005.77 1.47h.01c6.58 0 11.92-5.34 11.92-11.92 0-3.18-1.24-6.17-3.48-8.42zM12.04 21.8h-.01a9.86 9.86 0 01-5.03-1.38l-.36-.21-3.72.98 1-3.62-.24-.37a9.86 9.86 0 01-1.51-5.28c0-5.46 4.45-9.91 9.92-9.91a9.86 9.86 0 017.01 2.9 9.86 9.86 0 012.9 7.01c0 5.47-4.44 9.92-9.96 9.92zm5.45-7.43c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.5.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.21 5.09 4.5.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z"/></svg>' +
      '</a>' +
      '<a class="dcm-stick--phone" href="tel:' + phone + '" aria-label="Sună-ne" title="Telefon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>' +
      '</a>';
    document.body.appendChild(box);
  }

  // ---------- FAQ schema (rich-result eligibility) ----------
  // DISABLED 2026-06-09 — caused a duplicate FAQPage schema on the
  // homepage. The server-rendered FAQ section (dcm-faq.liquid or
  // the FAQ schema in seo-schema.liquid) already emits a valid
  // FAQPage JSON-LD block. This JS injection added a SECOND copy,
  // which Google Search Console flagged as "Câmp dublură FAQPage"
  // ("Duplicate field FAQPage") — both FAQPage entries then
  // showed up as invalid items in the rich-result eligibility
  // report. Keeping the function as a stub so any callers still
  // resolve; no-op = no extra schema injected.
  function injectFAQSchema() {
    /* no-op — see comment above */
  }

  // ---------- Image alt text auto-fill ----------
  function fillImageAltText() {
    document.querySelectorAll('img:not([alt]), img[alt=""]').forEach(function (img) {
      // Try to derive context-aware alt text
      var card = img.closest('.cat-card, .product-card, article, figure, .testimonial');
      var title = card?.querySelector('h1, h2, h3, h4, .cat-card__title, .product-card__title')?.textContent.trim();
      var src = img.src || '';
      var fileName = src.split('/').pop().split('?')[0].replace(/\.(jpg|jpeg|png|webp|gif|svg)$/i, '').replace(/[-_]+/g, ' ').trim();
      img.alt = title || fileName || 'DC MARKET — uși de garaj și industriale';
    });
  }

  function injectCookieBanner() {
    if (document.getElementById('dcm-cookie-banner')) return;
    if (localStorage.getItem('dcm-cookie-accepted') === '1') return;
    var b = document.createElement('div');
    b.id = 'dcm-cookie-banner';
    b.innerHTML = '<div id="dcm-cookie-banner__inner"><p>Folosim cookie-uri pentru a îmbunătăți experiența pe site. Continuând navigarea ești de acord cu <a href="/pages/politica-cookies">politica noastră de cookies</a>.</p><button id="dcm-cookie-banner__btn" type="button">Am înțeles</button></div>';
    document.body.appendChild(b);
    setTimeout(function () { b.classList.add('is-visible'); }, 400);
    document.getElementById('dcm-cookie-banner__btn').addEventListener('click', function () {
      localStorage.setItem('dcm-cookie-accepted', '1');
      b.classList.remove('is-visible');
      setTimeout(function () { b.remove(); }, 300);
    });
  }

  function fixAnnouncementSeparator() {
    document.querySelectorAll('.announcement__sep, .announcement__divider').forEach(function (el) {
      if (el.textContent.trim() === '|') {
        el.textContent = '·';
        el.style.color = '#f7941d';
        el.style.fontWeight = '700';
      }
    });
  }

  function patch() {
    // Hide Shopify's built-in cookie banner / privacy modal — keep only our custom one
    document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner, [data-shopify-pc-banner], [data-shopify-pc-modal], dialog[data-shopify-pc-modal], #shopify-pc-root').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
    cleanMobileMenu();
    // Re-show announcement if a previous version of this script hid it
    document.querySelectorAll('.announcement.announcement--contact, .shopify-section-group-header-group .announcement, .shopify-section-group-header-group #dcm-hazard-mid, .shopify-section-group-header-group hr.hazard').forEach(function (el) {
      if (el.style && el.style.display === 'none') el.style.removeProperty('display');
    });
    patchPasLabels();
    patchPhoneBox();
    fix404();
    fixAnnouncementSeparator();
    fillImageAltText();
    injectFAQSchema();
  }

  ready(function () {
    reinforceFavicon();
    reinforceThemeColor();
    applySEOForCurrentPage();
    injectCSS();
    injectStickyCTA();
    injectCookieBanner();
    patch();
    setTimeout(patch, 200);
    setTimeout(patch, 800);
    setTimeout(patch, 1600);
    new MutationObserver(patch).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', patch);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.header__menu-btn, [data-menu-open]')) {
        setTimeout(patch, 100);
        setTimeout(patch, 400);
      }
    });
  });

  // ============================================================
  // FORCE FLAT MOBILE Uși DROPDOWN (defeats DCM_USI_2LEVEL injection
  // in dcm-app-v3.js which Shopify keeps silently reverting our edits to).
  // ============================================================
  // The 2-level mobile mega expands "Uși Industriale" → Secționale, Rulouri,
  // etc. We don't want that. Owner wants tile click → /pages/usi-industriale
  // direct redirect, identical to desktop. This patch repeatedly tears down
  // the 2-level container and replaces it with the flat 5-link list.
  function forceFlatUsiMobile() {
    if (window.innerWidth > 989) return;
    var triggers = document.querySelectorAll('.mobile-menu .dcm-mega-trigger');
    triggers.forEach(function (trigger) {
      var label = trigger.querySelector('span:first-child');
      if (!label || label.textContent.trim().toLowerCase() !== 'uși') return;
      var item = trigger.closest('li');
      if (!item) return;
      var mega = item.querySelector('[data-dcm-mega]');
      if (!mega) return;
      // 2-level shape has .dcm-mega-cat-btn. Flat has only .dcm-mega__sub a.
      var isTwoLevel = !!mega.querySelector('.dcm-mega-cat-btn');
      if (!isTwoLevel) return;
      // Mutate the existing mega in-place so the wireSingleMega listener (which
      // captured this exact element) keeps working. Replace inner HTML with
      // the flat 5-link list and add --single class for tile styling.
      mega.classList.add('dcm-mega--single');
      mega.classList.remove('is-sub-open');
      mega.innerHTML =
        '<div class="dcm-mega__panel dcm-mega__sub is-active" data-sub="usi">' +
          '<ul>' +
            '<li><a href="/pages/usi-industriale"><span>Uși Industriale</span><span class="dcm-mega__arrow">→</span></a></li>' +
            '<li><a href="/pages/usi-rezistente-foc"><span>Uși rezistente la foc</span><span class="dcm-mega__arrow">→</span></a></li>' +
            '<li><a href="/pages/usi-pietonale"><span>Uși pietonale</span><span class="dcm-mega__arrow">→</span></a></li>' +
            '<li><a href="/pages/usi-spitale"><span>Uși spitale</span><span class="dcm-mega__arrow">→</span></a></li>' +
          '</ul>' +
        '</div>';
      item.removeAttribute('data-usi2-patched');
    });
  }
  // Run early + late + on every drawer open + on any DOM mutation in mobile-menu.
  forceFlatUsiMobile();
  ready(forceFlatUsiMobile);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__menu-btn, [data-menu-open]')) {
      setTimeout(forceFlatUsiMobile, 60);
      setTimeout(forceFlatUsiMobile, 200);
      setTimeout(forceFlatUsiMobile, 600);
    }
  });
  ready(function () {
    var ml = document.querySelector('.mobile-menu');
    if (ml) new MutationObserver(function () { forceFlatUsiMobile(); }).observe(ml, { childList: true, subtree: true });
  });
})();
